import { useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { usePageMeta } from "@/hooks/usePageMeta";
import { usePosts } from "@/hooks/usePosts";
import { BRAND, SECTIONS } from "@/lib/site";
import { PostCard } from "@/components/site/PostCard";

export default function BlogPage() {
  usePageMeta(`Handmade gift ideas | ${BRAND}`, "Step-by-step DIY gift ideas for kids to make, teachers, her, him, holidays, wrapping and last-minute budgets.");
  const posts = usePosts();
  const [params, setParams] = useSearchParams();
  const active = params.get("section") || "";
  const [more, setMore] = useState(12);
  const shown = (posts || []).filter((p) => !active || p.section === active);

  return (
    <div className="mx-auto max-w-6xl px-5 pt-14 sm:px-8" data-testid="blog-page">
      <p className="mb-3 text-xs font-semibold uppercase tracking-[0.2em] text-[#23324A]/55">Gift ideas</p>
      <h1 className="font-heading text-4xl font-semibold text-[#23324A] sm:text-5xl lg:text-6xl">Make something they'll keep</h1>
      <p className="mt-4 max-w-xl text-[#23324A]/75">Projects with supply lists, honest times and costs, and steps you can follow. - Kelly</p>
      <div className="mt-8 flex flex-wrap gap-2" data-testid="blog-filters">
        {[{ slug: "", short: "All" }, ...SECTIONS].map((s) => (
          <button key={s.slug || "all"} onClick={() => { setParams(s.slug ? { section: s.slug } : {}); setMore(12); }}
            className={`tab ${active === s.slug ? "tab-active" : ""}`} data-testid={`blog-filter-${s.slug || "all"}`}>{s.short}</button>
        ))}
      </div>
      {active && (
        <Link to={`/gifts/${active}`} className="mt-4 inline-block text-sm font-semibold text-[#23324A] underline decoration-[#F08A6C] underline-offset-4" data-testid="blog-section-link">
          Open the {SECTIONS.find((s) => s.slug === active)?.name} page
        </Link>
      )}
      {!posts && <p className="mt-10 text-sm text-[#23324A]/60">Loading…</p>}
      {posts && shown.length === 0 && <p className="mt-10 text-sm text-[#23324A]/60" data-testid="blog-empty">No ideas in this section yet.</p>}
      <div className="mt-10 grid gap-6 sm:grid-cols-2 lg:grid-cols-3" data-testid="blog-posts">
        {shown.slice(0, more).map((p, i) => <PostCard key={p.slug} post={p} index={i} />)}
      </div>
      {shown.length > more && (
        <button className="btn-line mt-10" onClick={() => setMore((m) => m + 12)} data-testid="blog-show-more">Show more ideas</button>
      )}
    </div>
  );
}
